import * as React from 'react';
import { FormInstance, Row } from 'antd';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import { StylesProps } from 'theme/jss-types';
import { getAddressFieldFromMapping } from '../generic-sub-layout-renderer';
import { addressFieldStyles } from './address-field.styles';

interface AddressFormFieldsProps extends StylesProps<typeof addressFieldStyles> {
    addressKey: string;
    form: FormInstance;
    addressFieldLayout?: string[];
    params: any;
}

const AddressFormFieldsComponent = (props: AddressFormFieldsProps) => {
    const {
        classes,
        addressKey,
        form,
        addressFieldLayout,
        params,
    } = props;

    const addressDetailsForm = addressFieldLayout?.map(
        (fieldKey: any) => getAddressFieldFromMapping(fieldKey, form, {
            ...params,
            parentObj: addressKey,
            key: undefined,
        }),
    );

    return (
        <div className={classes.addressFieldsGrid}>
            <Row gutter={20}>
                {addressDetailsForm}
            </Row>
        </div>
    );
};

const hocConfig: HocOptions = {
    connectJss: {
        useJss: true,
        styleSheet: addressFieldStyles,
    },
};

export default GenericHoc(hocConfig)(AddressFormFieldsComponent);
